import React, { useEffect } from "react";
import InfluencerCard from "../influencerCard/InfluencerCard";

// Stylesheet
import "./MoreInfluencers.css";

// Popup
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

// Assets
import influencers from "../../../../../assets/influencers.png";

function MoreInfluencers({ allInfluencerList, allInfluencer, setAllInfluencer }) {
  const [open, setOpen] = React.useState(false);
  const [newlist, setNewList] = React.useState([]);

  useEffect(() => {
    setNewList(allInfluencerList)
  },[allInfluencerList]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const filterInfluencers = (e) => {
    if(e.target.value.length > 0)
    {
      const filtered = allInfluencerList.filter(m =>  m.name.indexOf(e.target.value) > -1);
      setNewList(filtered);
    }else{
      setNewList(allInfluencerList);
    }
  }

  return (
    <div className="more-influencers">
      <Button className="extra-card" onClick={handleClickOpen}>
        <img src={influencers} alt="extra" />
        <p>
          See More <br /> Influencers
        </p>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className = "dialog-box"
      >
        <DialogTitle
          className="popup popup-title edit-profile-popup"
          id="responsive-dialog-title"
        >
          {"Find More Influencers"}
        </DialogTitle>
        <DialogActions className="wallet-options">
          <form>
            <input
              className="influencers-search"
              type="search"
              placeholder="Search"
              onChange={(e) => filterInfluencers(e)}
            />
          </form>

          <div
            style={{
              marginTop: "2rem",
            }}
            className="cards more-influencers-cards"
          >
            {newlist && newlist.map((item) => {
              return (
                <div
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (!allInfluencer.find((val) => val.uniqueID === item.uniqueID)) {
                      item.isSold = false;
                      setAllInfluencer(prev => [...prev, item]);
                    }
                  }}
                >
                  <InfluencerCard data={item} />
                </div>
              );
            })}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MoreInfluencers;
